import { Link } from '@tanstack/react-router';
import { ArrowUpRight, Users } from 'lucide-react';
import {} from '../components/ui/button';
import { Status, Media } from '../components/common';
import { useLab } from '../lib/service';

/** Platform actors promoted for reuse across series. */
export function CastLibrary() {
  const lab = useLab();
  return (
    <>
      <div className="page-heading">
        <div>
          <span className="eyebrow">THE PEOPLE</span>
          <h1>
            Your cast library<span>.</span>
          </h1>
          <p>Discover the characters and performers behind each story.</p>
        </div>
      </div>
      {!!lab.home?.library?.length && (
        <div className="cast-grid cast-library-grid">
          {lab.home.library.map((a) => (
            <div className="cast-card" key={a._id}>
              <Media assetId={lab.isDemo ? undefined : a.identityAssetId} />
              <div className="cast-card-body">
                <h3>{a.name}</h3>
                <p>{a.description}</p>
                <span className="version-tag">
                  {a.kind === 'platform' ? 'Reusable performer' : 'Custom performer'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="concept-list">
        {lab.home?.projects
          .filter((p) => p.pitchVersion > 0)
          .map((p) => (
            <Link
              key={p._id}
              to="/series/$projectId"
              params={{ projectId: p._id }}
              className="concept-row"
            >
              <span className="concept-symbol symbol-1">
                <Users size={22} />
              </span>
              <span className="concept-row-title">
                <strong>{p.title}</strong>
                <small>
                  {p.castLocked
                    ? 'Locked identities ready for production'
                    : 'Open the Cast tab to audition fictional performers'}
                </small>
              </span>
              <Status value={p.castLocked ? 'LOCKED' : 'CASTING'} />
              <ArrowUpRight size={18} />
            </Link>
          ))}
      </div>
    </>
  );
}
